import useSelectedDevicesHook from "./hooks/useSelectedDevices";
export {useMediaDevices, useBrowserPermissions} from "./context";
export const useSelectedDevices = useSelectedDevicesHook;